const citySelectsSearch = document.querySelectorAll('.wp-wyszukiwarka-pakietow-select');
const cityInputSearch = document.querySelectorAll('.wp-wyszukiwarka-pakietow-input');

if (cityInputSearch.length > 0) {
    const autocompleteOffcanvas = document.querySelector('.wp-wyszukiwarka-pakietow-autocomplete');
    const autocompleteResults = document.querySelector('.wp-wyszukiwarka-pakietow-autocomplete-results');
    const autocompleteClose = document.querySelector('.wp-wyszukiwarka-pakietow-input-close');

    if (autocompleteOffcanvas && autocompleteResults && autocompleteClose) {
        if(navigator.userAgent.indexOf('iPhone') > -1) {
            document.querySelector("[name=viewport]").setAttribute("content","width=device-width, initial-scale=1, maximum-scale=1");
        }

        const fetchResults = (input, cityName) => {
            const data = new FormData();
            data.append('action', 'get_facilities');
            data.append('ajaxnonce', pakietymedyczneJSON.ajaxnonce);
            data.append('city', cityName);
            data.append('placowki700', input.dataset.placowkiFirst);
            data.append('placowki1000', input.dataset.placowkiSecond);
            data.append('placowkiWlasne', input.dataset.placowkiWlasne);
        
            fetch(pakietymedyczneJSON.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        const resultsDiv = document.querySelector('.wp-wyszukiwarka-pakietow-results');
                        resultsDiv.innerHTML = '';
                        resultsDiv.innerHTML += data.data.html
                    } else {
                        console.error('Error:', data.data.message);
                    }
                })
                .catch((error) => {
                    console.error('Fetch Error:', error);
                });
        }

        const polishMap = {
            'ą': ['a'], 'ć': ['c'], 'ę': ['e'], 'ł': ['l', 'Ł'], 'ń': ['n'],
            'ó': ['o'], 'ś': ['s'], 'ź': ['z'], 'ż': ['z'],
            'Ą': ['A'], 'Ć': ['C'], 'Ę': ['E'], 'Ł': ['L', 'ł'], 'Ń': ['N'],
            'Ó': ['O'], 'Ś': ['S'], 'Ź': ['Z'], 'Ż': ['Z']
        };

        const generateVariants = (str) => {
            let variants = [''];

            for (let char of str) {
                if (polishMap[char]) {
                    let newVariants = [];
                    for (let variant of variants) {
                        for (let replacement of [...polishMap[char], char]) {
                            newVariants.push(variant + replacement);
                        }
                    }
                    variants = newVariants;
                } else {
                    variants = variants.map(variant => variant + char);
                }
            }
            return new Set(variants);
        }

        const autocompleteDOMStart = () => {
            document.body.classList.add('is-autocomplete');
            autocompleteResults.classList.add('is-fixed');
            autocompleteResults.parentElement.classList.add('is-fixed');
            autocompleteOffcanvas.parentElement.parentElement.style.height = '0';

            setTimeout(() => {
                window.scrollTo(0, 0);
                document.body.scrollTop = 0;
            }, 300);
        }

        const autocompleteDOMEnd = () => {
            autocompleteOffcanvas.parentElement.parentElement.style.height = '';
            document.body.classList.remove('is-autocomplete');
            autocompleteResults.classList.remove('is-fixed');
            autocompleteResults.parentElement.classList.remove('is-fixed');

            autocompleteResults.classList.remove('show');
        }

        const renderList = (cities, input) => {
            if(cities.length === 0) {
                const alertTemplate = document.getElementById("warning-message");
                const alert = alertTemplate.content.cloneNode(true);
                autocompleteResults.appendChild(alert);
            }
            cities.forEach(city => {
                const button = document.createElement('button');
                button.innerText = city;
                button.classList.add('wp-wyszukiwarka-pakietow__autocomplete-btn');
                autocompleteResults.appendChild(button);

                button.addEventListener('click', () => {
                    fetchResults(input, city);
                    input.value = city;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                    autocompleteDOMEnd();
                })
            })
        }

        const handleInputChange = (input) => {
            input.addEventListener('focus', () => {
                renderList(cities, input);
            }, {once: true})

            input.addEventListener('input', (e) => {
                const cityName = e.target.value;
                while (autocompleteResults.firstChild) {
                    autocompleteResults.removeChild(autocompleteResults.firstChild);
                }

                const query = cityName.toLowerCase();
                const matchingCities = cities.filter(city => {
                    const cityVariants = generateVariants(city.toLowerCase());
                    return [...cityVariants].some(variant => variant.includes(query));
                });
   
                renderList(matchingCities, input);
            })
        }

        const handleResultsMobile = () => {
            cityInputSearch.forEach(input => {
                input.addEventListener('focus', () => {
                    autocompleteDOMStart();
                })

                handleInputChange(input);

                autocompleteClose.addEventListener('click', () => {
                    autocompleteDOMEnd();
                })
            })
        }

        const handleResultsDesktop = () => {
            let firstFocus = true;
            cityInputSearch.forEach(input => {
                input.addEventListener('focusin', () => {
                    autocompleteResults.classList.add('show');
                })

                // input.addEventListener('focusout', () => {
                //     setTimeout(() => {
                //         autocompleteResults.classList.remove('show');
                //     }, 100);
                // })

                handleInputChange(input);
            })
        }

        const isOffcanvas = autocompleteOffcanvas.classList.contains("is-mobile");
        if (isOffcanvas) {
            handleResultsMobile();
        } else if (!isOffcanvas) {
            handleResultsDesktop();
        }

    }
}